"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.string.starts-with");
require("core-js/modules/es6.number.constructor");
var _cipher = require("@/api/activity/cipher");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _PhoneUserSelect = _interopRequireDefault(require("@/components/PhoneUserSelect"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'CipherJoinPane',
  components: {
    Pagination: _Pagination.default,
    PhoneUserSelect: _PhoneUserSelect.default
  },
  props: {
    activityId: {
      type: Number,
      required: true
    },
    activityTitle: {
      type: String,
      default: ''
    },
    initFilters: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      list: [],
      total: 0,
      listLoading: false,
      imgPath: process.env.VUE_APP_IMAGE_PATH,
      // 状态: 1-中奖未领取, 2-中奖已领取, 3-猜错未中奖, 4-中奖未领取(发券失败), 5-猜错已领取, 6-猜错未领取(发券失败)
      statusMap: {
        1: '中奖未领取',
        2: '中奖已领取',
        3: '猜错未中奖',
        4: '中奖未领取',
        5: '猜错已领取',
        6: '猜错未领取'
      },
      // 筛选用状态组（后端按组映射状态）：1-中奖已领取, 2-中奖未领取, 3-猜错已领取, 4-猜错未领取, 5-猜错未中奖
      statusOptions: [{
        value: 1,
        label: '中奖已领取'
      }, {
        value: 2,
        label: '中奖未领取'
      }, {
        value: 3,
        label: '猜错已领取'
      }, {
        value: 4,
        label: '猜错未领取'
      }, {
        value: 5,
        label: '猜错未中奖'
      }],
      statusTagType: {
        1: 'info',
        2: 'success',
        3: 'info',
        4: 'warning',
        5: 'success',
        6: 'warning'
      },
      listQuery: {
        page: 1,
        limit: 20,
        cipherId: this.activityId,
        type: null,
        statusGroup: null,
        userId: null
      }
    };
  },
  created: function created() {
    if (this.initFilters) {
      this.applyFilters(this.initFilters);
    } else {
      this.fetchData();
    }
  },
  methods: {
    // 应用筛选条件（参与数据点击跳转 / 已打开的列表切换条件）
    // type: 1-中奖(猜对), 2-猜错
    applyFilters: function applyFilters(filters) {
      if (!filters) {
        this.fetchData();
        return;
      }
      this.listQuery.page = 1;
      this.listQuery.type = filters.type != null ? filters.type : null;
      this.listQuery.statusGroup = filters.statusGroup != null ? filters.statusGroup : null;
      this.listQuery.userId = filters.userId || null;
      this.fetchData();
    },
    getAvatarUrl: function getAvatarUrl(userpic) {
      if (!userpic) return '';
      if (userpic.startsWith('http://') || userpic.startsWith('https://')) return userpic;
      return this.imgPath + userpic;
    },
    fetchData: function fetchData() {
      var _this = this;
      this.listLoading = true;
      var query = _objectSpread({}, this.listQuery);
      if (query.type === '' || query.type === undefined || query.type === null) delete query.type;
      if (query.statusGroup === '' || query.statusGroup === undefined || query.statusGroup === null) delete query.statusGroup;
      if (!query.userId) delete query.userId;
      (0, _cipher.getCipherJoinPage)(query).then(function (response) {
        _this.list = response.records || [];
        _this.total = response.total || 0;
        _this.listLoading = false;
      }).catch(function (error) {
        console.error('获取参与明细失败:', error);
        _this.listLoading = false;
        _this.list = [];
        _this.total = 0;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.fetchData();
    },
    // 补发奖励（仅发券失败的记录 4/6，即未领取的中奖/猜错记录可操作）
    handleResend: function handleResend(row) {
      var _this2 = this;
      var statusText = this.statusMap[row.status] || '';
      this.$confirm("\u786E\u5B9A\u8981\u4E3A\u7528\u6237\u300C".concat(row.userAlias || row.userMobile || row.userId, "\u300D\u8865\u53D1\u5956\u52B1\u5417\uFF1F\u5F53\u524D\u72B6\u6001\uFF1A").concat(statusText), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 1;
              return (0, _cipher.resendCipherJoin)(row.id);
            case 1:
              _this2.$message.success('补发成功');
              _this2.fetchData();
              _context.next = 3;
              break;
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              console.error('补发失败:', _t);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 2]]);
      }))).catch(function () {});
    }
  }
};